import {
    useAPIQuery,
    useGlobalAPIQueryContext,
} from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";

const CheckBOM = ({
    item_id,
    wo_id,
    salesorder_id,
    disabled,
    item_name,
    work_order_code,
    sales_order_no,
    setCurrentWIP,
    recheckBom,
    setRecheckBom,
}) => {
    const userID = secureLocalStorage.getItem("userID");
    const {
        handleSubmit,
        register,
        watch,
        formState: { errors, isValid },
        reset,
    } = useForm({
        mode: "onBlur",
    });
    const { invalidateApi } = useGlobalAPIQueryContext();

    const closeButtonRef = useRef(null);

    const columns = [
        {
            accessor: "item_code",
            header: "Item Id",
        },
        {
            accessor: "item_name",
            header: "Item Name",
        },
        {
            accessor: "category",
            header: "Category",
        },
        {
            accessor: "item_per_product",
            header: "Item/Pro",
        },
        {
            accessor: "allotted_stock",
            header: "Allotted Stock",
        },
        {
            accessor: "work_order_req_quantity",
            header: "Work Order Require Quantity",
        },
        {
            accessor: "uom",
            header: "UOM",
        },
        {
            accessor: "allocate",
            header: "Allocate",
            cell: (row) => (
                <>
                    {row.category === "WIP" ? (
                        <>
                            <p className="fs-8 text-success mt-2">
                                Available Stock: {row?.available}
                            </p>
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                data-bs-toggle="modal"
                                data-bs-target={`#allocate-wip`}
                                onClick={() => setCurrentWIP(row)}
                            >
                                Allot
                            </button>
                        </>
                    ) : (
                        row?.available
                    )}
                </>
            ),
        },
    ];

    const columnsRM = [
        {
            accessor: "item_code",
            header: "Item Id",
        },
        {
            accessor: "item_name",
            header: "Item Name",
        },
        {
            accessor: "category",
            header: "Category",
        },
        {
            accessor: "item_per_product",
            header: "Item/Pro",
        },
        {
            accessor: "stock_quantity",
            header: "Stock Quantity",
        },
        {
            accessor: "work_order_req_quantity",
            header: "Work Order Require Quantity",
        },
        {
            accessor: "uom",
            header: "UOM",
        },
    ];

    const [wips, setWips] = useState([]);
    const [rms, setRms] = useState([]);

    // To Allot the WIP Starts here
    const { useCreate: createAllotWIP } = useAPIQuery({
        key: "updateBOM",
        endpoint: `/api/allot-wip-rm/`,
    });

    const handleCloseModal = () => {
        if (closeButtonRef.current) {
            invalidateApi({ key: "api/work-order" });
            closeButtonRef.current.click();
        }
    };

    const handleAllotWIPSuccess = (data) => {
        Swal.fire({
            title: "WIP Allotted Successfully",
            text: data.message,
            icon: "success",
        }).then((result) => {
            handleCloseModal();
            reset({});
            setWips([]);
            setRms([]);
        });
    };

    const handleAllotWIPError = (data) => {
        Swal.fire({
            title: "Error Allotting WIP",
            text: data?.data?.data?.message,
            icon: "error",
        }).then((err) => {
            handleCloseModal();
            reset({});
            setWips([]);
            setRms([]);
        });
    };

    const { mutate: mutateAllotWIP, isPending } = createAllotWIP({
        successMessageFromServer: true,
        errorMessageFromServer: true,
        onSuccess: handleAllotWIPSuccess,
        onError: handleAllotWIPError,
        retry: 2,
    });
    // To Allot the WIP Ends here

    // Fetch the WIP and RM starts here
    const { useCreate } = useAPIQuery({
        key: "checkBOM",
        endpoint: `/api/check-bom/`,
    });

    const handleSuccessCheckBOM = (data) => {
        setRecheckBom(false);
        const wipsAva = data?.data?.filter(
            (item) => item?.item?.category === "WIP"
        );
        const rmAva = data?.data?.filter(
            (item) => item?.item?.category === "Raw Material"
        );
        setWips(
            wipsAva.map((wip) => ({
                id: wip?.id,
                item_code: wip?.item?.item_code,
                item_id: wip?.item?.id,
                item_name: wip?.item?.item_name,
                category: wip?.item?.category,
                allotted_stock: wip?.allotted_stock,
                work_order_req_quantity: wip?.work_order_req_quantity,
                item_per_product: wip?.bom?.item_per_product,
                uom: wip?.item?.uom,
                available: wip?.item?.stock_quantity ?? 0,
                wo_id: wip?.work_order?.id,
            }))
        );
        setRms(
            rmAva.map((rm) => ({
                id: rm?.id,
                item_code: rm?.item?.item_code,
                item_id: rm?.item?.id,
                item_name: rm?.item?.item_name,
                category: rm?.item?.category,
                work_order_req_quantity: rm?.work_order_req_quantity,
                item_per_product: rm?.bom?.item_per_product,
                uom: rm?.item?.uom,
                stock_quantity: rm?.item?.stock_quantity,
                // available: rm?.item?.stock_quantity,
            }))
        );
    };

    const handleErrorCheckBOM = (data) => {
        setRecheckBom(false);
    };

    const { mutate: mutateCheckBOM, isPending: loadingCheckbom } = useCreate({
        errorMessageFromServer: true,
        successMessageFromServer: true,
        onSuccess: handleSuccessCheckBOM,
        onError: handleErrorCheckBOM,
        retry: 2,
    });

    const handleCheckBom = () => {
        if (item_id && wo_id) {
            Swal.fire({
                title: "Alert",
                icon: "warning",
                text: "This will over-ride the existing BOM for the work order. Do you want to continue?",
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.isConfirmed) {
                    mutateCheckBOM({
                        data: {
                            item_id: item_id,
                            work_order_id: wo_id,
                            created_by: userID,
                            updated_by: userID,
                        },
                    });
                    const button = document.createElement("button");
                    button.className = "d-none";
                    button.setAttribute("data-bs-toggle", "modal");
                    button.setAttribute(
                        "data-bs-target",
                        `#check-bom-${wo_id}`
                    );
                    document.body.appendChild(button);
                    button.click();
                    button.remove();
                }
            });
        }
    };
    // Fetch the WIP and RM ends here

    const onSubmit = (data) => {
        console.log(data);
    };

    const handleSubmitCheckBOM = () => {
        let values = {};
        values = wips.map((wip) => ({
            id: wip?.id,
            allotted_stock: watch(`allot-${wip.id}`),
            is_stock_allotted: true,
        }));

        // values = [
        //   ...values,
        //   ...rms.map((rm) => ({
        //     id: rm.item_id,
        //     allotted_stock: watch(`allot-${rm.id}`),
        //     is_stock_allotted: true,
        //   })),
        // ];
        mutateAllotWIP({
            data: {
                work_order_id: wo_id,
                sales_order_id: salesorder_id,
                // is_locked: true,
                bulk_upload: values,
                created_by: userID,
                updated_by: userID,
            },
        });
    };

    useEffect(() => {
        if (recheckBom) {
            mutateCheckBOM({
                data: {
                    item_id: item_id,
                    work_order_id: wo_id,
                    created_by: userID,
                    updated_by: userID,
                },
            });
        }
    }, [recheckBom]);

    useEffect(() => {
        return () => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
                document.body.classList.remove("modal-open");
                document.body.style = "";
            }
        };
    }, []);

    return (
        <>
            <div
                className="modal fade m-0 p-0"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex={-1}
                id={`check-bom-${wo_id}`}
                aria-modal
            >
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <button
                            type="button"
                            className="close"
                            data-bs-dismiss="modal"
                            ref={closeButtonRef}
                            onClick={() =>
                                invalidateApi({ key: "api/work-order" })
                            }
                        >
                            <em
                                className="icon ni ni-cross"
                                aria-hidden="true"
                            ></em>
                        </button>
                        <div className="modal-header">
                            <h5 className="modal-title">Check BOM</h5>
                        </div>
                        <div className="modal-body">
                            <div className="nk-block">
                                <div className="profile-ud-list">
                                    <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                            <span className="profile-ud-label">
                                                Item Name
                                            </span>
                                            <span className="profile-ud-value">
                                                {item_name}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                            <span className="profile-ud-label">
                                                Sales Order No
                                            </span>
                                            <span className="profile-ud-value">
                                                {sales_order_no}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                            <span className="profile-ud-label">
                                                Work Order Code
                                            </span>
                                            <span className="profile-ud-value">
                                                {work_order_code}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content d-flex">
                                        <h6
                                            className="nk-block-title"
                                            style={{ fontSize: "1.3rem" }}
                                        >
                                            WIP
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <Table
                                data={wips}
                                columns={columns}
                                isLoading={loadingCheckbom}
                                pagination={false}
                                selectRows={false}
                                globalSearch={false}
                                filterModal={false}
                                editRows={false}
                                deleteRows={false}
                            />
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content d-flex">
                                        <h6
                                            className="nk-block-title"
                                            style={{ fontSize: "1.3rem" }}
                                        >
                                            Raw Material
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <Table
                                data={rms}
                                columns={columnsRM}
                                isLoading={loadingCheckbom}
                                pagination={false}
                                selectRows={false}
                                globalSearch={false}
                                filterModal={false}
                                editRows={false}
                                deleteRows={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <button
                type="button"
                className="btn btn-sm btn-primary"
                // data-bs-toggle="modal"
                // data-bs-target={`#check-bom-${wo_id}`}
                onClick={handleCheckBom}
                disabled={disabled}
            >
                Generate BOM
            </button>
        </>
    );
};

export default CheckBOM;
